import { Navigate, Outlet } from "react-router-dom";
import useAuthService from "../session/AuthService";

const PrivateRoutes = () => {
  const token = useAuthService.getToken();
  const userData = useAuthService.getUserData(); // Assume you can get user data incl. user type here
  const path = window.location.pathname;

  if (!token || token === "Bearer null") {
    return <Navigate to="/login" replace />;
  }

  // If accessing /admin routes, check if user is admin
  if (
    path.startsWith("/admin") &&
    !(
      userData?.uType === 1 ||
      userData?.uType === 2 ||
      userData?.uType === 3 ||
      userData?.uType === 4 ||
      userData?.uType === 5
    )
  ) {
    // Not admin, redirect to login or wallet dashboard
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default PrivateRoutes;
